import { CategoryFilterItem } from '../interfaces/filter';

export function getItemsForFilter(categoria, categorie) {
    let famiglie = categorie[0];
    let sottofamiglie = categorie[1];
    let gruppo = categorie[2];
    let sottogruppo = categorie[3];
    if (!categoria) {
        return famiglie.map(x => makeCategoryFilterItem('child', x, x.codicefamiglia));
    }
    else {
        let ids = categoria.split('-');
        let items = [];
        if (ids.length >= 1) {
            let found = famiglie.find(obj => obj.codicefamiglia == ids[0]);
            if (!found)
                return items;
            let type : 'current' | 'parent' = ids.length == 1 ? 'current' : 'parent';
            items.push(makeCategoryFilterItem(type, found, ids[0]));
            if (ids.length >= 2) {
                found = sottofamiglie.find(obj => obj.codicefamiglia == ids[0] && obj.codicesfamiglia == ids[1]);
                if (!found)
                    return items;
                type = ids.length == 2 ? 'current' : 'parent';
                items.push(makeCategoryFilterItem(type, found, `${ids[0]}-${ids[1]}`));

                if (ids.length >= 3) {
                    found = gruppo.find(obj => obj.codicefamiglia == ids[0] && obj.codicesfamiglia == ids[1] && obj.codicegruppo == ids[2]);
                    if (!found)
                        return items;
                    type = ids.length == 3 ? 'current' : 'parent';
                    items.push(makeCategoryFilterItem(type, found, `${ids[0]}-${ids[1]}-${ids[2]}`));

                    if (ids.length >= 4) {
                        found = sottogruppo.find(obj => obj.codicefamiglia == ids[0] && obj.codicesfamiglia == ids[1] && obj.codicegruppo == ids[2] && obj.codicesgruppo == ids[3]);
                        if (!found)
                            return items;
                        type = ids.length == 4 ? 'current' : 'parent';
                        items.push(makeCategoryFilterItem(type, found, `${ids[0]}-${ids[1]}-${ids[2]}-${ids[4]}`));
                    }
                    else {
                        let children = sottogruppo.filter(obj => obj.codicefamiglia == ids[0] && obj.codicesfamiglia == ids[1] && obj.codicegruppo == ids[2]);
                        items.push(...children.map(x => makeCategoryFilterItem('child', x, ids[0] + '-' + ids[1] + '-' + ids[2] + '-' + x.codicesgruppo)));
                    }
                }
                else {
                    let children = gruppo.filter(obj => obj.codicefamiglia == ids[0] && obj.codicesfamiglia == ids[1]);
                    items.push(...children.map(x => makeCategoryFilterItem('child', x, ids[0] + '-' + ids[1] + '-' + x.codicegruppo)));
                }
            }
            else {
                let children = sottofamiglie.filter(obj => obj.codicefamiglia == ids[0]);
                items.push(...children.map(x => makeCategoryFilterItem('child', x, ids[0] + '-' + x.codicesfamiglia)));
            }
        }

        return items;
    }
}

function makeCategoryFilterItem(type: 'parent' | 'current' | 'child', category, slug): CategoryFilterItem {
    return {
        slug: slug,
        name: category.descrizione,
        type,
        category: {
            id: category.slug,
            name: category.descrizione,
            type: 'shop',
            children: null,
            parents: null,
            slug: null,
            items: null,
            image: null,
            path: null,
            customFields: null
        },
        count: 0,
    };
}